const backendUrl = process.env.VUE_APP_BACKEND_URL;

const state = {
  meeting: {
    status: String,
    meetingId: String,
  },
  isRunning: false,
  meetHistory: []  // Новое состояние для хранения истории митов
};

const mutations = {
  updateMeeting(state, meeting) {
    state.meeting = meeting;
  },
  updateIsRunning(state, isRunning) {
    state.isRunning = isRunning;
  },
  updateMeetHistory(state, meetHistory) {
    state.meetHistory = meetHistory;  // Обновляем meetHistory
  }
};

const actions = {
  async get_meeting_status({ commit, dispatch }) {
    try {
      const response = await fetch(`${backendUrl}/get_status_meeting`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });
      const data = await response.json();
      if (response.ok) {
        if (data.is_active) {
          commit('updateIsRunning', true);
          const meetingToPush = {
            status: data.status,
            meetingId: data.meeting_id
          };
          commit('updateMeeting', meetingToPush);
        } else {
          if (state.isRunning == true) {
            await dispatch('get_meet_history'); // вызываем другое action
          }
          commit('updateIsRunning', false);
        }
        return;
      } else if (response.status == 401 || response.status == 404) {
        return 'error auth';
      }
    } catch (error) {
      console.log(error);
      return 'error auth';
    }
  },
  
  async start_meeting({ commit }, url) {
    try {
      const response = await fetch(`${backendUrl}/start_recording`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ meeting_url: url }),
        credentials: 'include',
      });
  
      if (response.status === 422) {
        return false;
      } else if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
  
      if (data && !('error' in data)) {
        await this.dispatch('get_meeting_status');
        commit('updateIsRunning', true);
        return data;
      }
  
      return false;
    } catch (error) {
      console.log('An error occurred:', error);
      return false;
    }
  },
  async stop_meeting({ commit, dispatch }) {
    try {
      const response = await fetch(`${backendUrl}/stop_container`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });
  
      if (response.status === 422) {
        return false;
      } else if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
  
      if (data && !('error' in data)) {
        await dispatch('get_meeting_status');
        await dispatch('get_meet_history')
        commit('updateIsRunning', false);
        return data;
      }
  
      return false;
    } catch (error) {
      console.log('An error occurred:', error);
      return false;
    }
  },

  // Функция для запроса истории митов
  async get_meet_history({ commit }) {
    try {
      const response = await fetch(`${backendUrl}/get_meet_history`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });
      const data = await response.json();
      if (response.ok && data.meets) {
        // Преобразуем каждый объект в массиве meets
        const meetsInCamelCase = data.meets.map(meet => toCamelCase(meet));
        commit('updateMeetHistory', meetsInCamelCase);  // Обновляем meetHistory
      }
    } catch (error) {
      console.log('Error fetching meet history:', error);
    }
  }
};

function toCamelCase(obj) {
  return Object.keys(obj).reduce((acc, key) => {
    const camelKey = key.replace(/_([a-z])/g, (g) => g[1].toUpperCase()); // Преобразуем ключи
    acc[camelKey] = obj[key];
    return acc;
  }, {});
}

export default {
  state,
  mutations,
  actions
};
